export default __webpack_public_path__ + "static/media/person_1.ab920196.png";